import { render, staticRenderFns } from "./ChangeRole.vue?vue&type=template&id=4f4d7dd1&"
import script from "./ChangeRole.vue?vue&type=script&lang=ts&"
export * from "./ChangeRole.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports